import React from 'react';

interface DecorativeWavesProps {
  className?: string;
}

export const DecorativeWaves: React.FC<DecorativeWavesProps> = ({ className = '' }) => {
  return (
    <div className={`w-full h-36 relative  ${className}`}>
      {/* Primeira onda - verde */}
      <div className="absolute left-0 top-0">
        <svg width="1920" height="155" viewBox="0 0 1920 155" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path 
            d="M-98.001 145.345C838.6 -266.488 1081.1 371.388 1965.91 67.8633" 
            stroke="var(--verde-1, #598648)" 
            strokeWidth="4"
          />
        </svg>
      </div>
      
      {/* Segunda onda - salmão */}
      <div className="absolute left-[53.98px] top-[23px]">
        <svg width="1920" height="66" viewBox="0 0 1920 66" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path 
            d="M2007.53 1.96973C1008.83 177.927 778.731 -91.3266 -44.0166 49.0649" 
            stroke="var(--salmao, #F05A49)" 
            strokeWidth="4"
          />
        </svg>
      </div>
    </div>
  );
};
